(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["blog-filter-chips"] && !Shopify.designMode) return;
  try {
    // 每次只绑定当前支柱 section，Theme Editor 重载不会叠加监听器。
  function bindBlogFilters(scope) {
    scope.querySelectorAll('[data-blog-filter]:not([data-blog-filter-bound])').forEach(function (filter) {
      filter.dataset.blogFilterBound = 'true';
      var root = filter.closest('[data-blog-pillar-main]');
      if (!root) return;
      var selections = {};
      var mode = filter.dataset.filterMode;

      function applyFilters() {
        var itemSelector = mode === 'gift' ? '.blog-product-picks [data-blog-filter-item]' : mode === 'hobby' ? '.blog-compare-table [data-blog-filter-item]' : '[data-blog-topic-item]';
        var items = root.querySelectorAll(itemSelector);
        var visible = 0;
        items.forEach(function (item) {
          var matches = Object.keys(selections).every(function (group) {
            var value = selections[group];
            if (!value) return true;
            if (group === 'feature') return item.dataset[value] === 'true';
            var dataKey = group === 'budget' ? 'price' : group;
            var haystack = (item.dataset[dataKey] || '').split(' ');
            return haystack.indexOf(value) !== -1;
          });
          item.hidden = !matches;
          if (matches) visible += 1;
        });
        root.querySelectorAll('[data-blog-filter-status]').forEach(function (status) { status.textContent = filter.dataset.matchesTemplate.replace('__COUNT__', visible); });
        root.querySelectorAll('[data-blog-filter-empty]').forEach(function (empty) { empty.hidden = visible !== 0; });
        if (mode === 'gift') {
          var params = new URLSearchParams(window.location.search);
          ['recipient', 'occasion', 'budget'].forEach(function (key) { selections[key] ? params.set(key, selections[key]) : params.delete(key); });
          window.history.replaceState({}, '', window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash);
        }
      }

      filter.addEventListener('click', function (event) {
        var button = event.target.closest('[data-filter-value]');
        if (!button) return;
        var group = button.closest('[data-filter-group]').dataset.filterGroup;
        selections[group] = button.dataset.filterValue;
        button.closest('[data-filter-group]').querySelectorAll('[data-filter-value]').forEach(function (peer) { peer.setAttribute('aria-pressed', peer === button ? 'true' : 'false'); });
        applyFilters();
      });
      root.addEventListener('click', function (event) {
        if (!event.target.closest('[data-blog-filter-clear]')) return;
        selections = {};
        filter.querySelectorAll('[data-filter-group]').forEach(function (group) { group.querySelectorAll('[data-filter-value]').forEach(function (button, index) { button.setAttribute('aria-pressed', index === 0 ? 'true' : 'false'); }); });
        applyFilters();
      });

      if (mode === 'gift') {
        var params = new URLSearchParams(window.location.search);
        ['recipient', 'occasion', 'budget'].forEach(function (group) {
          var value = params.get(group);
          var button = value && filter.querySelector('[data-filter-group="' + group + '"] [data-filter-value="' + CSS.escape(value) + '"]');
          if (button) { selections[group] = value; button.click(); }
        });
      }
    });
  }
  bindBlogFilters(document);
  document.addEventListener('shopify:section:load', function (event) { bindBlogFilters(event.target); });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blog-search-az"] && !Shopify.designMode) return;
  try {
    function bindBlogSearch(scope) {
    scope.querySelectorAll('[data-blog-search]:not([data-blog-search-bound])').forEach(function (search) {
      search.dataset.blogSearchBound = 'true';
      var root = search.closest('[data-blog-pillar-main]');
      if (!root) return;
      var input = search.querySelector('[data-blog-search-input]');
      var status = search.querySelector('[data-blog-search-status]');
      var items = Array.from(root.querySelectorAll('[data-blog-search-item]'));
      var activeLetter = '';

      // 字母状态同时依据计划标题与已发布文章标题，便于先浏览完整内容规划。
      search.querySelectorAll('[data-blog-letter]').forEach(function (button) {
        button.disabled = !items.some(function (item) { return (item.dataset.blogTitle || '').trim().startsWith(button.dataset.blogLetter); });
      });

      function applySearch() {
        var query = input.value.trim().toLowerCase();
        var visibleUrls = new Set();
        items.forEach(function (item) {
          var title = item.dataset.blogTitle || '';
          var matches = (!query || title.indexOf(query) !== -1) && (!activeLetter || title.trim().startsWith(activeLetter));
          item.hidden = !matches;
          if (matches) visibleUrls.add(item.dataset.blogSearchUrl || title);
        });
        if (query || activeLetter) {
          root.querySelectorAll('.blog-topic-group__all').forEach(function (details) {
            details.open = Array.from(details.querySelectorAll('[data-blog-search-item]')).some(function (item) { return !item.hidden; });
          });
        }
        status.textContent = search.dataset.shownTemplate.replace('__COUNT__', visibleUrls.size);
      }

      input.addEventListener('input', function () { activeLetter = ''; search.querySelectorAll('[data-blog-letter]').forEach(function (button) { button.setAttribute('aria-pressed', 'false'); }); applySearch(); });
      search.addEventListener('click', function (event) {
        var button = event.target.closest('[data-blog-letter]');
        if (!button || button.disabled) return;
        activeLetter = button.getAttribute('aria-pressed') === 'true' ? '' : button.dataset.blogLetter;
        search.querySelectorAll('[data-blog-letter]').forEach(function (peer) { peer.setAttribute('aria-pressed', peer.dataset.blogLetter === activeLetter ? 'true' : 'false'); });
        applySearch();
      });
    });
  }
  bindBlogSearch(document);
  document.addEventListener('shopify:section:load', function (event) { bindBlogSearch(event.target); });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-customization-fields"] && !Shopify.designMode) return;
  try {
    (() => {
    const bindModule = (module) => {
      if (!module || module.dataset.customizationBound === 'true') return;

      const form = module.closest('form') || document.getElementById(module.dataset.formId || '');
      if (!form) return;

      module.dataset.customizationBound = 'true';

      const updateCount = (input) => {
        const counter = module.querySelector(`[data-customization-count][data-target="${input.id}"]`);
        if (!counter) return;
        const maxLength = input.getAttribute('maxlength') || '';
        counter.textContent = `${input.value.length}/${maxLength}`;
      };

      const syncHiddenInput = (targetId, value) => {
        if (!targetId) return;

        const hiddenInput = document.getElementById(targetId);
        if (!hiddenInput) return;

        hiddenInput.value = value;
        hiddenInput.disabled = value === '';
      };

      const syncSelectMetadata = (select) => {
        const selectedOption = select.selectedOptions && select.selectedOptions[0];
        const handleValue = selectedOption ? (selectedOption.dataset.handle || '') : '';
        const gidValue = selectedOption ? (selectedOption.dataset.gid || '') : '';

        syncHiddenInput(select.dataset.targetHandleInput || '', handleValue);
        syncHiddenInput(select.dataset.targetGidInput || '', gidValue);
      };

      module.querySelectorAll('[data-customization-count]').forEach((counter) => {
        const target = module.querySelector(`#${counter.dataset.target}`);
        if (!target) return;
        updateCount(target);
        target.addEventListener('input', () => updateCount(target));
      });

      module.querySelectorAll('[data-customization-select]').forEach((select) => {
        syncSelectMetadata(select);
        select.addEventListener('change', () => syncSelectMetadata(select));
      });

      form.addEventListener('submit', () => {
        const temporarilyDisabled = [];

        module.querySelectorAll('[data-customization-trim]').forEach((field) => {
          field.value = field.value.trim();
        });

        module.querySelectorAll('[data-customization-skip-empty="true"]').forEach((field) => {
          if (field.value.trim() !== '') return;
          field.disabled = true;
          temporarilyDisabled.push(field);
        });

        module.querySelectorAll('[data-customization-hidden-value]').forEach((field) => {
          if (field.value.trim() !== '') return;
          field.disabled = true;
          temporarilyDisabled.push(field);
        });

        if (!temporarilyDisabled.length) return;

        window.setTimeout(() => {
          temporarilyDisabled.forEach((field) => {
            field.disabled = false;
          });
        }, 0);
      }, true);
    };

    const init = (root) => {
      const scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('[data-product-customization]').forEach(bindModule);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document));
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      init(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
